/**
 *
 * OnPropertyBringingRequestType14326 constants
 *
 */

export const MOVEMENT_MATERIAL_VALUES_DATA = '4022223559000';
export const PROPERTY_BRINGING = '4022223527000';
export const PROPERTY_REMOVAL = '4022223531000';
